export const SCOUT_TEMPLATE_MODES = {
  NEW: 'new',
  QUICK: 'quick-save',
  EDIT: 'edit',
  SAVE_AS: 'save as',
  DELETE: 'delete',
  FAVOURITE: 'favourite',
};
